import React from 'react';

// Clanster brand mark — the real transparent-background logo asset. Rendered
// as a plain <img> so the browser handles caching. `size` prop scales both
// dimensions; drop-shadow keeps the mark readable on light AND dark chrome.
export default function LogoMark({ size = 60 }) {
  return (
    <img
      src="/logo.png"
      alt="Clanster"
      width={size}
      height={size}
      className="logo-mark"
      style={{
        width: size,
        height: size,
        objectFit: 'contain',
        filter: 'drop-shadow(0 4px 10px rgba(6, 8, 14,0.14))',
      }}
      data-testid="clanster-logo"
    />
  );
}
